import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BettingDistribution from './BettingDistribution';
import ParticipantList from './ParticipantList';
import LeaderBoard from './LeaderBoard';
import './ParticipantSection.css';

const ParticipantSection = ({ race }) => {
  const [activeTab, setActiveTab] = useState('leaderboard');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div>
      <div className='divider mt-8 mb-4'></div>
      <div className="participant-section-header py-4">
        <div className="participant-section-title">
          <h3 className='font-bold'>Betting Distribution</h3>
        </div>
      </div>

      <div className="participant-section-content">
        <BettingDistribution participants={race.participants} tokens={race.tokens} />
      </div>
      <div className='divider mt-2 mb-8'></div>
      <div className="participant-section-title mb-4">
        <h3 className='font-bold'>Race Participants</h3>
        <span className="participant-count h-6">
          {race.participants?.length || 0} Active
        </span>
      </div>
      <div className="category-filters mb-6 flex">
        <button
          onClick={() => handleTabChange('leaderboard')}
          className={`category-button flex-grow ${activeTab === 'leaderboard' ? 'active' : ''}`}
        >
          Leaderboard
        </button>
        <button
          onClick={() => handleTabChange('participants')}
          className={`category-button flex-grow ${activeTab === 'participants' ? 'active' : ''}`}
        >
          Participants
        </button>
      </div>
      <div className="participant-section-content">
        {activeTab === 'leaderboard' && <LeaderBoard participants={race.participants} />}
        {activeTab === 'participants' && <ParticipantList participants={race.participants} />}
      </div>
    </div>
  );
};

ParticipantSection.propTypes = {
  race: PropTypes.shape({
    participants: PropTypes.arrayOf(
      PropTypes.shape({
        address: PropTypes.string.isRequired,
        avatar: PropTypes.string.isRequired,
        bet: PropTypes.number.isRequired,
        token: PropTypes.string.isRequired,
        joinedAgo: PropTypes.string.isRequired,
      })
    ).isRequired,
    tokens: PropTypes.arrayOf(
      PropTypes.shape({
        symbol: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default ParticipantSection;